import styled from 'styled-components';
import leftArrow from '../images/left-arrow.svg';
import rightArrow from '../images/right-arrow.svg';

const Container = styled.div`
  padding: ${({ title }) => (title ? '50px 20px 100px' : '67px 20px 100px')};
  margin: 0 auto;
  width: 700px;

  .in-page-features--navigation-content {
    max-width: 575px;
    margin: 0 auto;
    position: relative;

    .in-page-features--navigation-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 22px;
      cursor: pointer;

      .in-page-features--navigation-item-icon {
      }

      .in-page-features--navigation-item-title {
        font-weight: var(--font-weight-500);
        font-size: var(--font-size-18);
        line-height: var(--line-height-150);
        color: ${({ isDarkBackground }) => (isDarkBackground ? 'var(--white)' : 'var(--darkest)')};
      }
    }

    &:before {
      position: absolute;
      content: ' ';
      width: 50px;
      height: 100%;
      background: ${(props) =>
        `linear-gradient(to right, ${props.background}ff, ${props.background}00)`};
      z-index: 1;
      left: -2px;
      pointer-events: none;
    }

    &:after {
      position: absolute;
      content: ' ';
      width: 50px;
      height: 100%;
      background: ${(props) =>
        `linear-gradient(to left, ${props.background}ff, ${props.background}00)`};
      z-index: 1;
      pointer-events: none;
      right: -1px;
      top: 0;
    }
  }

  .in-page-features--main-content {
    margin-top: 25px;

    .in-page-features--image-content {
      max-width: 100%;
      margin: 0 auto;
      padding: 0;
      height: 275px;
      overflow: hidden;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;

      .gatsby-image-wrapper {
        max-height: 225px;
      }

      video {
        display: flex;
        margin: auto;
      }
    }

    .in-page-features--video-content {
      max-width: 100%;
      margin: 0 auto;
      padding: 0;
      height: 225px;

      video {
        max-height: 225px;
        margin: 0px auto;
        display: block;
      }
    }

    .in-page-features--description-content {
      margin-top: 17px;
      max-width: 600px;
      margin: 0 auto;

      .in-page-features--description-content-container {
        font-weight: var(--font-weight-500);
        font-size: var(--font-size-16);
        line-height: var(--line-height-150);
        text-align: center;
        margin-bottom: 20px;

        h2 {
          color: ${({ isDarkBackground }) =>
            isDarkBackground ? 'var(--white)' : 'var(--darkest)'};
        }

        h2:not(.font-p) {
          font-size: var(--font-size-20);
          font-weight: var(--font-weight-900);
        }
      }
    }
  }

  .slick-slide.slick-current {
    .in-page-features--navigation-item {
      .in-page-features--navigation-item-title {
        color: var(--titan-blue-3);
      }
    }
  }

  .slick-prev,
  .slick-next {
    bottom: -52px;
    border-radius: 50%;
    top: auto;
    width: 32px;
    height: 32px;
    z-index: 1;
    box-shadow: 0 3px 6px 1px rgba(160, 161, 188, 0.35);

    &:before {
      width: 32px;
      height: 32px;
      color: transparent;
    }
  }

  .slick-prev {
    left: 0;
    background-image: url('${leftArrow}') !important;
    background-color: var(--white) !important;
    background-repeat: no-repeat !important;
    background-size: 9px !important;
    background-position: center !important;
  }

  .slick-next {
    right: 0;
    background-image: url('${rightArrow}') !important;
    background-color: var(--white) !important;
    background-repeat: no-repeat !important;
    background-size: 9px !important;
    background-position-x: 13px !important;
    background-position-y: center !important;
  }

  .slick-dots {
    bottom: -34px;

    li {
      margin: 0 1px;

      button:before {
        font-size: var(--font-size-13);
        opacity: 1;
        color: var(--grey-4);
      }

      &.slick-active {
        button:before {
          color: var(--titan-blue-3);
        }
      }
    }
  }

  .in-page-features--description-content-container {
    padding-top: 30px;
  }

  .in-page-features--content-mobile-container
    .in-page-features--navigation-content
    .in-page-features--navigation-item {
    padding: 0 10px;
  }

  @media (max-width: 767px) {
    width: 100%;

    .in-page-features--navigation-content {
      max-width: 450px;
    }
  }

  @media (max-width: 575px) {
    padding-top: 30px;
    .in-page-features--navigation-content {
      max-width: 350px;
      height: 30px;
    }

    .in-page-features--navigation-item-title {
      font-size: var(--font-size-16) !important;
    }
  }
`;

export { Container };
